import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.string.trim.js";
import { defineComponent as _defineComponent } from 'vue';
import { getCurrentInstance } from 'vue';
import { ReviewEventType, useSubmitReviewEventMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'SubmitEventForm',
  props: {
    reviewRequestId: null,
    ventureId: null,
    disabled: {
      type: Boolean
    },
    disabledReason: null
  },
  emits: ['submitted'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _ref2 = getCurrentInstance(),
      proxy = _ref2.proxy;
    var router = useRouter();
    var comment = ref('');
    var commentError = ref(false);
    var submitting = ref(false);
    var confirmOpen = ref(false);
    var pendingEventType = ref(null);
    var _useSubmitReviewEvent = useSubmitReviewEventMutation({
        refetchQueries: ['listReviewRequests', 'getReviewRequest', 'listReviewEvents']
      }),
      submitReviewEvent = _useSubmitReviewEvent.mutate;
    watch(confirmOpen, function (open) {
      if (!open && !submitting.value) {
        pendingEventType.value = null;
      }
    });
    var confirmTitle = computed(function () {
      if (pendingEventType.value === 'APPROVED') {
        return String(proxy.$t('confirmTitleApprove'));
      }
      if (pendingEventType.value === 'EDITS_REQUESTED') {
        return String(proxy.$t('confirmTitleEdits'));
      }
      return '';
    });
    var confirmBody = computed(function () {
      if (pendingEventType.value === 'EDITS_REQUESTED') {
        return String(proxy.$t('confirmBodyEdits'));
      }
      return String(proxy.$t('confirmBody'));
    });
    var openConfirm = function openConfirm(eventType) {
      if (eventType === 'EDITS_REQUESTED' && !comment.value.trim()) {
        commentError.value = true;
        window.$nuxt.$emit('userMsg', {
          message: proxy.$t('commentRequiredForEdits'),
          color: 'error'
        });
        return;
      }
      pendingEventType.value = eventType;
      confirmOpen.value = true;
    };
    var confirmSubmit = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var eventType;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              eventType = pendingEventType.value;
              if (eventType) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              submitting.value = true;
              _context.prev = 4;
              _context.next = 7;
              return submitReviewEvent({
                input: {
                  reviewRequestId: props.reviewRequestId,
                  ventureId: props.ventureId,
                  eventType: eventType === 'APPROVED' ? ReviewEventType.Approved : ReviewEventType.EditsRequested,
                  comment: comment.value.trim()
                }
              });
            case 7:
              window.$nuxt.$emit('userMsg', {
                color: 'green',
                message: proxy.$t('success')
              });
              comment.value = '';
              confirmOpen.value = false;
              emit('submitted');
              _context.next = 13;
              return router.push("/portfolio/review/".concat(props.reviewRequestId));
            case 13:
              _context.next = 18;
              break;
            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](4);
              window.$nuxt.$emit('userError', {
                message: (_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message) || String(_context.t0)
              });
            case 18:
              _context.prev = 18;
              submitting.value = false;
              pendingEventType.value = null;
              return _context.finish(18);
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[4, 15, 18, 22]]);
      }));
      return function confirmSubmit() {
        return _ref3.apply(this, arguments);
      };
    }();
    return {
      __sfc: true,
      props: props,
      emit: emit,
      proxy: proxy,
      router: router,
      comment: comment,
      commentError: commentError,
      submitting: submitting,
      confirmOpen: confirmOpen,
      pendingEventType: pendingEventType,
      submitReviewEvent: submitReviewEvent,
      confirmTitle: confirmTitle,
      confirmBody: confirmBody,
      openConfirm: openConfirm,
      confirmSubmit: confirmSubmit
    };
  }
});